var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "AccessRoleModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal uar-modal",
            title: `${_vm.isUpdate ? "Update" : "New"} Role Privileges`,
            "hide-footer": "",
          },
          on: {
            show: function ($event) {
              return _vm.initModal()
            },
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "uar-role-row", attrs: { "no-gutters": "" } },
            [
              _c("b-col", { attrs: { cols: "4" } }, [
                _c(
                  "div",
                  { staticClass: "uar-field" },
                  [
                    _c("span", { staticClass: "uar-label" }, [
                      _vm._v("Role Name"),
                    ]),
                    _vm._v(" "),
                    _vm.isUpdate
                      ? _c("span", { staticClass: "uar-role-name" }, [
                          _vm._v(_vm._s(_vm.updatedRoleName)),
                        ])
                      : _c("b-form-input", {
                          staticClass: "uar-input",
                          attrs: { placeholder: "Enter role name" },
                          model: {
                            value: _vm.updatedRoleName,
                            callback: function ($$v) {
                              _vm.updatedRoleName = $$v
                            },
                            expression: "updatedRoleName",
                          },
                        }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "4" } }, [
                _c(
                  "div",
                  { staticClass: "uar-field" },
                  [
                    _c("span", { staticClass: "uar-label" }, [
                      _vm._v("Organization"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticClass: "uar-select",
                        scopedSlots: _vm._u([
                          {
                            key: "first",
                            fn: function () {
                              return [
                                _c(
                                  "b-form-select-option",
                                  { attrs: { value: null, disabled: "" } },
                                  [_vm._v("Select Organization")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.updatedOrg,
                          callback: function ($$v) {
                            _vm.updatedOrg = $$v
                          },
                          expression: "updatedOrg",
                        },
                      },
                      [
                        _vm._v(" "),
                        _vm._l(_vm.organizations, function (org) {
                          return _c(
                            "b-form-select-option",
                            { key: org.id, attrs: { value: org.id } },
                            [_vm._v(_vm._s(org.company_name))]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "4" } }, [
                _c(
                  "div",
                  { staticClass: "uar-field" },
                  [
                    _c("span", { staticClass: "uar-label" }, [
                      _vm._v("Default Route"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticClass: "uar-select",
                        scopedSlots: _vm._u([
                          {
                            key: "first",
                            fn: function () {
                              return [
                                _c(
                                  "b-form-select-option",
                                  { attrs: { value: null, disabled: "" } },
                                  [_vm._v("Select Default Route")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.updatedRoute,
                          callback: function ($$v) {
                            _vm.updatedRoute = $$v
                          },
                          expression: "updatedRoute",
                        },
                      },
                      [
                        _vm._v(" "),
                        _vm._l(_vm.routes, function (route) {
                          return _c(
                            "b-form-select-option",
                            { key: route.name, attrs: { value: route.value } },
                            [
                              _vm._v(
                                _vm._s(route.name) +
                                  " (" +
                                  _vm._s(route.route) +
                                  ")"
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "uar-section" },
            [
              _c(
                "div",
                {
                  staticClass: "uar-section-header uar-section-header--tools",
                  on: {
                    click: function ($event) {
                      _vm.toolsCollapsed = !_vm.toolsCollapsed
                    },
                  },
                },
                [
                  _c("div", { staticClass: "uar-section-title-row" }, [
                    _c("span", { staticClass: "uar-dot uar-dot--tools" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "uar-section-title" }, [
                      _vm._v("MMP Tools"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "uar-chevron",
                      class: { open: _vm.toolsCollapsed },
                    },
                    [
                      _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                        _c("polyline", { attrs: { points: "6 9 12 15 18 9" } }),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  model: {
                    value: _vm.toolsCollapsed,
                    callback: function ($$v) {
                      _vm.toolsCollapsed = $$v
                    },
                    expression: "toolsCollapsed",
                  },
                },
                [
                  _vm.row
                    ? _c(
                        "div",
                        { staticClass: "uar-module-grid" },
                        _vm._l(
                          _vm.allModules.filter(
                            (m) => m.module_type === "tool"
                          ),
                          function (module) {
                            return _c(
                              "label",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.right",
                                    value: {
                                      title: module.module_description,
                                      customClass: "ac-tooltip",
                                    },
                                    expression:
                                      "{ title: module.module_description, customClass: 'ac-tooltip' }",
                                    modifiers: { hover: true, right: true },
                                  },
                                ],
                                key: module.module_name,
                                staticClass: "uar-checkbox-label",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedModules,
                                      expression: "selectedModules",
                                    },
                                  ],
                                  staticClass: "uar-checkbox",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value: {
                                      id: module.id,
                                      module_name: module.module_name,
                                    },
                                    checked: Array.isArray(_vm.selectedModules)
                                      ? _vm._i(_vm.selectedModules, {
                                          id: module.id,
                                          module_name: module.module_name,
                                        }) > -1
                                      : _vm.selectedModules,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.selectedModules,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = {
                                            id: module.id,
                                            module_name: module.module_name,
                                          },
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.selectedModules = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.selectedModules = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.selectedModules = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "uar-checkbox-custom",
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "uar-module-name" }, [
                                  _vm._v(_vm._s(module.module_name)),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "uar-section" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "uar-section-header uar-section-header--features",
                  on: {
                    click: function ($event) {
                      _vm.featuresCollapsed = !_vm.featuresCollapsed
                    },
                  },
                },
                [
                  _c("div", { staticClass: "uar-section-title-row" }, [
                    _c("span", { staticClass: "uar-dot uar-dot--features" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "uar-section-title" }, [
                      _vm._v("MMP Features"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "uar-chevron",
                      class: { open: _vm.featuresCollapsed },
                    },
                    [
                      _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                        _c("polyline", { attrs: { points: "6 9 12 15 18 9" } }),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  model: {
                    value: _vm.featuresCollapsed,
                    callback: function ($$v) {
                      _vm.featuresCollapsed = $$v
                    },
                    expression: "featuresCollapsed",
                  },
                },
                [
                  _vm.row
                    ? _c(
                        "div",
                        { staticClass: "uar-module-grid" },
                        _vm._l(
                          _vm.allModules.filter(
                            (m) => m.module_type === "feature"
                          ),
                          function (module) {
                            return _c(
                              "label",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.right",
                                    value: {
                                      title: module.module_description,
                                      customClass: "ac-tooltip",
                                    },
                                    expression:
                                      "{ title: module.module_description, customClass: 'ac-tooltip' }",
                                    modifiers: { hover: true, right: true },
                                  },
                                ],
                                key: module.module_name,
                                staticClass: "uar-checkbox-label",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedModules,
                                      expression: "selectedModules",
                                    },
                                  ],
                                  staticClass: "uar-checkbox",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value: {
                                      id: module.id,
                                      module_name: module.module_name,
                                    },
                                    checked: Array.isArray(_vm.selectedModules)
                                      ? _vm._i(_vm.selectedModules, {
                                          id: module.id,
                                          module_name: module.module_name,
                                        }) > -1
                                      : _vm.selectedModules,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.selectedModules,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = {
                                            id: module.id,
                                            module_name: module.module_name,
                                          },
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.selectedModules = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.selectedModules = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.selectedModules = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "uar-checkbox-custom",
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "uar-module-name" }, [
                                  _vm._v(_vm._s(module.module_name)),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "uar-section" },
            [
              _c(
                "div",
                {
                  staticClass: "uar-section-header uar-section-header--admin",
                  on: {
                    click: function ($event) {
                      _vm.adminCollapsed = !_vm.adminCollapsed
                    },
                  },
                },
                [
                  _c("div", { staticClass: "uar-section-title-row" }, [
                    _c("span", { staticClass: "uar-dot uar-dot--admin" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "uar-section-title" }, [
                      _vm._v("MMP Administrative Capabilities"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "uar-chevron",
                      class: { open: _vm.adminCollapsed },
                    },
                    [
                      _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                        _c("polyline", { attrs: { points: "6 9 12 15 18 9" } }),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  model: {
                    value: _vm.adminCollapsed,
                    callback: function ($$v) {
                      _vm.adminCollapsed = $$v
                    },
                    expression: "adminCollapsed",
                  },
                },
                [
                  _vm.row
                    ? _c(
                        "div",
                        { staticClass: "uar-module-grid" },
                        _vm._l(
                          _vm.allModules.filter(
                            (m) => m.module_type === "admin"
                          ),
                          function (module) {
                            return _c(
                              "label",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.right",
                                    value: {
                                      title: module.module_description,
                                      customClass: "ac-tooltip",
                                    },
                                    expression:
                                      "{ title: module.module_description, customClass: 'ac-tooltip' }",
                                    modifiers: { hover: true, right: true },
                                  },
                                ],
                                key: module.module_name,
                                staticClass: "uar-checkbox-label",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedModules,
                                      expression: "selectedModules",
                                    },
                                  ],
                                  staticClass: "uar-checkbox",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value: {
                                      id: module.id,
                                      module_name: module.module_name,
                                    },
                                    checked: Array.isArray(_vm.selectedModules)
                                      ? _vm._i(_vm.selectedModules, {
                                          id: module.id,
                                          module_name: module.module_name,
                                        }) > -1
                                      : _vm.selectedModules,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.selectedModules,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = {
                                            id: module.id,
                                            module_name: module.module_name,
                                          },
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.selectedModules = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.selectedModules = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.selectedModules = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "uar-checkbox-custom",
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "uar-module-name" }, [
                                  _vm._v(_vm._s(module.module_name)),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "uar-submit-row" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleSubmit()
                    },
                  },
                },
                [_vm._v("Submit")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }